import { render, staticRenderFns } from "./main.vue?vue&type=template&id=8fca321c"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=8fca321c&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8fca321c')) {
      api.createRecord('8fca321c', component.options)
    } else {
      api.reload('8fca321c', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=8fca321c", function () {
      api.rerender('8fca321c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RichTextarea/main.vue"
export default component.exports